export const UI_3_3_tableRow = [
  [
    {
      cellName: "알람발생 관리번호",
      id: "alarmNo",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "산업단지명",
      id: "complexInloName",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "회사명",
      id: "companyInloName",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "공장명",
      id: "plantInloName",
      row: 1,
      col: 1,
      style: { width: "6%" },
    },
    {
      cellName: "알람종류",
      id: "alarmClCd",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "설비명",
      id: "moName",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "설비번호",
      id: "moNo",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "알람내용",
      id: "alarmMsg",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "알람발생시각",
      id: "occurDtm",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "알람조치실적여부",
      id: "fpactYn",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },  
  ]
]


